//DBTables
import { useState } from "react";
import { DBModule, ModuleTypeFamily, ModuleTypeId } from "../../types/DBTables";
import { post } from "../../modules/server";
import Notify from "devextreme/ui/notify";
import { useForm } from "react-hook-form";

import ValidationSummaryMessages from "./ValidationSummaryMessages";
import ModuleEditor from "./ModuleEditor";
import { DTOBuilding, DTOModule } from "../../types/building";
import { configurationHandler } from "../../modules/ConfigurationHandler";
import { Button, Card } from "react-bootstrap";
import { useGlobalData } from "../GlobalDataProvider";

interface IProps {
  building: DTOBuilding;
  module: DTOModule;
  cancelConfiguration: (m: DBModule | undefined) => void;
}

const ModuleConfiguratorForm = ({ building, module, cancelConfiguration }: IProps) => {
  const [configurationData, setConfigurationData] = useState(
    () => configurationHandler.getModuleFormData(building, module)
    //module?.data && module?.data !== "{}" ? JSON.parse(module.data) : configurationHandler.getModuleDefaultData(building, module)
  );

  const formHook = useForm({
    defaultValues: configurationData || {},
  }); //{register,  handleSubmit,  formState: { errors }}

  const {
    handleSubmit,
    formState: { errors },
  } = formHook;

  const globalData = useGlobalData();
  const moduleTypes = globalData.moduleTypes;

  const onSubmit = async (data: any) => {
    const dataPrepped = configurationHandler.fixFormData(building, module.moduleTypeId, data);

    try {
      const sData = JSON.stringify(dataPrepped);
      const res = await post("SaveModuleData", { id: module.id, data: sData });
      if (res?.succeeded) {
        module.data = res.module.data;
        module.status = res.module.status;
        // setConfigurationData(data);
        cancelConfiguration(undefined);
        Notify("Ändringarna har sparats", "success");
      } else {
        Notify(res.message, "error");
      }
    } catch (err) {
      Notify(err, "error");
    }
  };

  const onCancel = () => {
    cancelConfiguration(undefined);
  };

  const onHelp = () => {
    const isDirektEl = globalData.moduleTypes.find((mt) => mt.id === module.moduleTypeId)?.family === ModuleTypeFamily.VärmeEl;
    if (isDirektEl) {
      PubSub.publish("ShowHelp", "help_VarmeDirektEl");
    } else {
      PubSub.publish("ShowHelp", "help_" + module.moduleTypeId);
    }
  };
  ////moduleTypes.find((mt) => mt.id === m.moduleTypeId)?.displayName

  const getHeaderTitle = () => {
    const m = module;
    const moduleTypeId = m.moduleTypeId;
    const moduleType = moduleTypes.find((mt) => mt.id === moduleTypeId);
    const family = moduleType?.family;

    if (family === ModuleTypeFamily.VärmeEl) {
      return "Konfigurering " + m.name;
    } else if (moduleType !== undefined && moduleTypeId === ModuleTypeId.Byggnadsdata) {
      return "Konfigurering " + m.name;
    } else {
      return "Konfigurering " + m.name + " - " + moduleType?.displayName;
    }
  };
  const headerTitle =
    module.moduleTypeId === ModuleTypeId.Byggnadsdata
      ? "Konfigurering " + module.name
      : "Konfigurering " + module.name + " - " + moduleTypes.find((mt) => mt.id === module.moduleTypeId)?.displayName;

  return (
    <>
      <Card border="0px">
        <Card.Header>{getHeaderTitle()}</Card.Header>
        <form onSubmit={handleSubmit(onSubmit)} className="ModuleConfiguratorForm">
          <Card.Body>
            <div style={{ minHeight: "300px", paddingRight: 12, paddingLeft: 4 }}>
              <ModuleEditor configurationData={configurationData} formHook={formHook} module={module} building={building} />
            </div>
            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
              <div className="flex-grow-1">
                <ValidationSummaryMessages errors={errors} />
              </div>
            </div>
          </Card.Body>
          <Card.Footer>
            <div className="module">
              <button type="button" className="btn btn-info col text-end" onClick={onHelp}>
                Hjälp
              </button>
            </div>
            <div className="footerGroup">
              <button type="button" className="btn btn-secondary col text-end" onClick={onCancel}>
                Avbryt
              </button>
              <button type="submit" className="btn btn-primary col text-end">
                Spara
              </button>
            </div>
          </Card.Footer>
        </form>
      </Card>
    </>
  );
};

export default ModuleConfiguratorForm;
